import React, { useEffect, useState, Fragment, useContext, useRef } from 'react';
import axios from 'axios';
import { LoginContext } from '../../hooks/context/LoginContext';
import $ from 'jquery';
import jQuery from 'jquery';
import DataTable from 'datatables.net';
import Spinner from 'react-bootstrap/Spinner'
import ReactDOM from 'react-dom';
import Cookies from 'universal-cookie';
import MiSelect from '../../componentes/formulario/MiSelect';
import BaseSelect from "react-select";
import swal from 'sweetalert';
import { alertService } from '../../services/alertservice';
import MiSelectLarge from '../../componentes/formulario/MiSelectLarge';
import MiInputDataTableLargeInv from '../../componentes/formulario/MiInputDatabTableLargeInv';
import SpinnerFloat from '../../componentes/ui/SpinnerFloat';

import { SRLWrapper } from 'simple-react-lightbox';

import { getApiUrl, getPantDocFromNivel, setStockOptionsSelectUbiLarge, getDecodedCookie, btnsImportExportFile, importFileToBBDD } from '../../helpers/helperApp';

import 'datatables.net';
import 'datatables.net-dt';
import 'datatables.net-bs4';
import 'datatables.net-buttons';
import 'datatables.net-buttons-bs4';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-select';
import 'datatables.net-rowreorder';
import 'datatables.net-rowgroup';
import 'datatables.net-responsive';

let date = new Date();
let mesHoy = date.getMonth() + 1;
let h = date.getDate();
let hoy = (h < 10 ? h = '0'+h : h = h )+'/'+(mesHoy < 10 ? mesHoy = '0'+mesHoy : mesHoy = mesHoy )+'/'+date.getFullYear();

var botones = [
    {
        extend: 'pdf',
        filename: hoy,
        text: `<i style='font-size: 20px;' class='fal fa-file-pdf'></i>`,
        className: 'btn btn-flat mr-1 btn-outline-secondary',
        orientation: 'landscape', 
        title: hoy,
        exportOptions: {
            columns: ':visible'
        }
    },
    {
        extend: 'excel',
        filename: hoy,
        text: `<i style='font-size: 20px;' class='fal fa-file-excel'></i>`,
        className: 'btn btn-flat mr-1 btn-outline-secondary',
        title: hoy,
        exportOptions: {
            columns: ':visible'
        }
    }, 
];

function MiDataTableLarge(props){

    const cookies = new Cookies();
    const { apiKey, confApp } = useContext(LoginContext);
    const loginState = useContext(LoginContext);
    
    // ***** props *****
    const { id, data, saveData, columnas, formulario, optionSelectUbi, optionSelectUni, inputNum1, swaldelete, confPantalla, extraColumns } = props;
    let { buttons, ordering, order, searching, paging, select, saveLoadingTable, loadingTable, columnactions, traduction, linkColumns, functionClickTd, pagelength, columnsFunctionClickTd, selectUbi, selectUni, idFiltro, editar, importexcel, docBloqueado, importExportFile, fnReloadTable, idRegImportExport, controles } = props;

    const tableRef = useRef(null);
    const fileInputRef = useRef(null);

    // Índices de columna calculados dinámicamente según extraColumns
    // Se guardan en refs para que sean accesibles fuera del useEffect (handleChangeUbi, handleChangeNum1, etc.)
    const idxCantidadRef = useRef(1);
    const idxUbiRef      = useRef(2);
    const idxAccionesRef = useRef(3);
    
    const [loadingSelectUbi, saveLoadingSelectUbi] = useState(false);
    const [optionsSelectUbiState, saveOptionsSelectUbiState] = useState(optionSelectUbi);
    const [optionsSelectUbiStateBackUp, saveOptionsSelectUbiStateBackUp] = useState(optionSelectUbi);   
    
    
    useEffect(()=>{
   
        // Calcular offset dinámico según columnas extra insertadas antes de los índices fijos
        // y actualizar los refs para que los handlers externos los lean correctamente
        const idxCantidad = columnas.findIndex(c => c.data === 'cantidad');
        const idxUbi      = columnas.findIndex(c => c.data === 'ubicacionNom');
        const idxAcciones = columnas.findIndex(c => c.data === 'borrar');

        idxCantidadRef.current = idxCantidad !== -1 ? idxCantidad : 2;
        idxUbiRef.current      = idxUbi      !== -1 ? idxUbi      : 3;
        idxAccionesRef.current = idxAcciones !== -1 ? idxAcciones : 4;

        if(idxCantidadRef.current === -1) idxCantidadRef.current = 2;
        if(idxUbiRef.current === -1)      idxUbiRef.current      = 3;
        if(idxAccionesRef.current === -1) idxAccionesRef.current = 4;

        const accionesMiDataTable = columnas.find(column => column["title"] === columnactions);

        if( accionesMiDataTable !== undefined ){
            columnas.splice( (columnas.length-1), 1 );
        }

        if( linkColumns != undefined ){
            for( let i = 0; i < columnas.length; i++ ){
                columnas[i].createdCell = (td, cellData, rowData, row, col) => {
                    if( linkColumns[i] != undefined ){
                        if ('style' in rowData){
                            $(td).addClass(rowData["style"]);
                        }
                        if( linkColumns[i].link == "/documentos" ){
                            linkColumns[i].link = getPantDocFromNivel(getDecodedCookie('nivel'));
                        }
                        if( linkColumns[i].data.includes("/") && linkColumns[i].link != "" ){
                            const links = linkColumns[i].data.split("/");
                            $(td).html("<a href='"+window.location.origin+linkColumns[i].link+"/"+rowData[links[0]]+"/"+rowData[links[1]]+"' >"+cellData+"</a>");
                        }else if( linkColumns[i].link != "" ){
                            $(td).html("<a href='"+window.location.origin+linkColumns[i].link+"/"+rowData[linkColumns[i].data]+"' >"+cellData+"</a>");
                        }
                    } 
                    if( 'foto' in rowData || 'img' in rowData ){
                        if( cellData ){
                            if( cellData.includes('/assets/')  ){
                                $(td).html("<img src='"+getApiUrl(window.location.origin)+cellData+"' style='width: 100px !important; cursor: pointer;' />");
                            }
                        }else{
                            $(td).html("<span></span>");
                        }
                    }                   
                    if( functionClickTd ){
                        if( columnsFunctionClickTd ){
                            if( columnsFunctionClickTd.includes(col) ){
                                $(td).on('click', function (e) {
                                    e.preventDefault();
                                    functionClickTd(e, rowData);
                                });
                            }
                        }else{
                            $(td).on('click', function (e) {
                                e.preventDefault();
                                functionClickTd(e, rowData);
                            });
                        }                        
                    }                    
                }
            }
        }else{
            for( let i = 0; i < columnas.length; i++ ){
                // No sobreescribir createdCell si ya tiene uno (columnas extra con createdCell propio)
                if( columnas[i].createdCell ) continue;
                columnas[i].createdCell = (td, cellData, rowData, row, col) => {
                    if ('style' in rowData){
                        $(td).addClass(rowData["style"]);
                    }
                    if( 'foto' in rowData || 'img' in rowData ){
                        if( cellData ){
                            if( cellData.includes('/assets/')  ){
                                let templateFoto = `
                                <div>                                   
                                        <div class="containerImgTablePending">
                                            <img class="imgUplmTablePending" src=${getApiUrl(window.location.origin)+cellData} />
                                        </div>                                                                                                                                        
                                </div>
                                `;
                                $(td).html(templateFoto);
                            }
                        }else{
                            $(td).html("<span></span>");
                        }
                    }
                    if( functionClickTd ){
                        if( columnsFunctionClickTd ){
                            if( columnsFunctionClickTd.includes(col) ){
                                $(td).on('click', function (e) {
                                    e.preventDefault();
                                    functionClickTd(e, rowData);
                                });
                            }
                        }else{
                            $(td).on('click', function (e) {
                                e.preventDefault();
                                functionClickTd(e, rowData);
                            });
                        }                        
                    }                    
                }
            }
        }

        buttons === undefined || buttons === true || buttons === "true" ? buttons = 'Bfrtip' : buttons = 'frtip';
        ordering === undefined ? ordering = true : ordering = ordering;
        order === undefined ? order = [[0,"asc"]] : order = order;
        searching === undefined ? searching = true : searching = searching;
        paging === undefined ? paging = true : paging = paging;
        pagelength === undefined ? pagelength = traduction.defaultpagelength : pagelength = pagelength;
        select === undefined ? select = false : select = select;

        columnas.map((columna, i) => {            
            if( i == idxAcciones ){
                columna.createdCell = (td, cellData, rowData, row, col) => {  
                    let templateNecesario = ReactDOM.render(
                        <div className="flex-center">
                            {/* <a 
                                className="btn btn-outline-primary mr-1"
                                href={getPantDocFromNivel(getDecodedCookie('nivel'))+"/"+rowData["iddoc"]+"/"+rowData["id"]} 
                            >
                                <i className="fal fa-eye"></i>  
                            </a> */}
                            {
                                docBloqueado == false 
                                ?
                                    <span 
                                        id={ rowData.id } 
                                        className="btn btn-outline-danger deleteRow mr-1" 
                                        onClick={ e => { handleDeleteItem(e, rowData) } }>
                                            <i  
                                                id={ rowData.id }
                                                className="fal fa-trash-alt deleteRow"
                                                onClick={ e => { handleDeleteItem(e, rowData) }}
                                            >
                                            </i>
                                    </span>
                                :
                                    null
                            }
                            {
                                editar 
                                ?
                                    <span 
                                        id={ rowData.id } 
                                        className="btn btn-outline-primary mr-1" 
                                        onClick={ e => { handleEditar(e, rowData) } }>
                                            <i  
                                                id={ rowData.id }
                                                className="fal fa-edit"
                                                onClick={ e => { handleEditar(e, rowData) }}
                                            >
                                            </i>
                                    </span>
                                :
                                    null 
                            }
                        </div>
                    ,td);
                    $(td).addClass(rowData.style);
                    $(td).html(templateNecesario)
                } 
            }
        })

        if( importExportFile == true ){                        
            botones = [...botones];
            botones = btnsImportExportFile(saveLoadingTable, traduction, fileInputRef, botones, id, data, idRegImportExport);
        }

        let auxColumnDefs = [
            { "type": "html-input-uni", "targets": 0 },
            { "type": "html-input",     "targets": idxCantidad },
            { "type": "html-input-ubi", "targets": idxUbi }
        ];

        // rowCallback compartido
        const rowCallbackFn = function(row, data, index){
            for (let item of row.children) {
                if( item.outerText.includes("#") ){
                    item.bgColor = item.outerText;
                    item.innerText = "";
                }
            }

            // Columna 0 - Unidad
            const tdUni = row.children[0];
            ReactDOM.render(
                <LoginContext.Provider value={loginState}>
                    <div className='row pt-2'>
                        <div className='col-12'>
                            <MiSelectLarge
                                regActual={idRegImportExport ? idRegImportExport : 0}
                                value={{ value: data.articulo, label: data.articuloNom }}
                                saveValue={saveData}
                                saveValueIsArray={{ id: data.id, valuekey: "articulo", labelkey: "articuloNom" }}
                                label={""}
                                col={12}
                                confPantalla={confPantalla}
                                dataType={controles.iduni.datatype}
                                dataSql={controles.iduni.data}
                                multiLinea={controles.iduni.multilinea}
                                functionAfterChange={e => handleChangeUni(e, data)}
                                readOnly={docBloqueado == true || data.uniLocked == true ? true : false}
                            />
                        </div>
                    </div>    
                </LoginContext.Provider>,
                tdUni
            );

            // Columna idxCantidad - Cantidad        
            const tdCantidad = row.children[idxCantidad];                            
            ReactDOM.render(
                <LoginContext.Provider value={loginState}>
                    <div className="row pt-2">
                        <div className="col-12" >
                            <div className='form-group' style={{marginBottom: "8px"}}>
                                <MiInputDataTableLargeInv                                   
                                    valueProp={data.cantidad}
                                    saveValueProp={saveData}
                                    functionAfterChange={e => handleChangeNum1(e, data)} 
                                    saveValueIsArray={{id : data.id, valuekey : "cantidad"}}                                                 
                                    readOnly={docBloqueado == true || data.num1Locked == true ? true : false} 
                                    disabled={docBloqueado == true || data.num1Locked == true ? true : false}                                            
                                />                                                                          
                            </div>                           
                        </div>                            
                    </div>
                </LoginContext.Provider>,
                tdCantidad
            );

            // Columna idxUbi - Ubicación
            const tdUbi = row.children[idxUbi];
            const renderValue = setStockOptionsSelectUbiLarge([{ value: data.ubicacionactual, label: data.ubicacionNom }])[0];
            ReactDOM.render(
                <LoginContext.Provider value={loginState}>
                    <div className='row pt-2'>
                        <div className='col-12'>
                            <MiSelectLarge
                                regActual={idRegImportExport ? idRegImportExport : 0}
                                value={renderValue}
                                saveValue={saveData}
                                saveValueIsArray={{id : data.id, valuekey : "ubicacionactual", labelkey : "ubicacionNom"}}
                                label={""}
                                col={12}
                                confPantalla={confPantalla}
                                dataType={controles.idubi.datatype}
                                dataSql={controles.idubi.data}
                                multiLinea={controles.idubi.multilinea}
                                functionAfterChange={e => handleChangeUbi(e, data)}
                                unidad={{value: data.articulo, label: data.articuloNom}}
                                minCharSearch={0}
                                readOnly={docBloqueado == true || data.ubiLocked == true ? true : false}  
                            />                                
                        </div>
                    </div>                           
                </LoginContext.Provider>,
                tdUbi
            ); 
        };
        
        let currentPage = 0;
        let resetToFirstPage = false;

        if ($.fn.DataTable.isDataTable("."+id)) {
            const existingTable = $("."+id).DataTable();
            if (existingTable.context[0]._formularioId !== formulario.id) {
                resetToFirstPage = true;
            } else {
                currentPage = existingTable.page();
            }
            existingTable.destroy();
            $("."+id).empty();
        }

        const dtConfig = {
            mark: true,
            rowId: function(a) { return '#row-' + a.id; },
            columnDefs: auxColumnDefs,
            dom: buttons,
            data: data && data.length > 0 ? data : null,
            columns: columnas,
            ordering: ordering,
            order: order,
            searching: searching,
            paging: paging,
            select: select,
            buttons: [botones],
            responsive: false, 
            autoWidth: false,
            retrieve: true,
            pageLength: parseInt(pagelength),
            lengthMenu: [
                [ 10, 25, 50, 100 ],
                [ '10', '25', '50', '100' ]
            ],
            deferRender: true,
            language: {
                "sProcessing":    traduction.sprocessing.title,
                "sLengthMenu":    traduction.slengthmenu.title,
                "sZeroRecords":   traduction.szerorecords.title,
                "sEmptyTable":    traduction.semptytable.title,
                "sInfo":          traduction.sinfo.title,
                "sInfoEmpty":     traduction.sinfoempty.title,
                "sInfoFiltered":  traduction.sinfofiltered.title,
                "sInfoPostFix":   traduction.sinfopostfix.title,
                "sSearch":        traduction.ssearch.title,
                "sUrl":           traduction.surl.title,
                "sInfoThousands": traduction.sinfothousands.title,
                "sLoadingRecords": traduction.sloadingrecords.title,
                "oPaginate": {
                    "sFirst":    "<<",
                    "sLast":     ">>",
                    "sNext":     ">",
                    "sPrevious": "<"
                },
                "oAria": {
                    "sSortAscending":  traduction.ssortascending.title,
                    "sSortDescending": traduction.ssortdescending.title
                },
                select: { rows: traduction.rows.title },
                buttons: {
                    copyTitle: traduction.copytitle.title,
                    copyKeys: traduction.copykeys.title,
                    copySuccess: {
                        _: traduction.copysuccess.many.title,
                        1: traduction.copysuccess.one.title
                    },
                }        
            },
            rowCallback: rowCallbackFn
        };
    
        const tabla = $("."+id).DataTable(dtConfig);
        tabla.context[0]._formularioId = formulario.id;

        if (resetToFirstPage) {
            tabla.page(0).draw(false);
        } else {
            tabla.page(currentPage).draw(false);
        }
        
        if( saveLoadingTable ){
            saveLoadingTable(false); 
        }               
        
    }, [data, formulario.id, docBloqueado])

    const handleImportFileToBBDD = (e, saveLoadingTable, traduction, id, fnReloadTable, idRegImportExport) => {        
        importFileToBBDD(saveLoadingTable, traduction, id, fnReloadTable, idRegImportExport, e)
    }

    const handleChangeUbi = async (e, rowData) => {    
        let idLinea = rowData.id;
        let idUbi = rowData.ubicacionactual;   

        saveData(prev =>
            prev.map(r => r.id === idLinea ? { ...r, ubiLocked: true } : r)
        );

        const dataForm = new FormData();      
        dataForm.append("validacion", apiKey());
        dataForm.append("idlinea", idLinea);
        dataForm.append("idubi", idUbi);
        dataForm.append("iduni", rowData.articulo)
        const respuesta = await axios.post(getApiUrl(window.location.origin)+"/edirap/updateUbicacion",dataForm);      
                
        saveData(prev =>
            prev.map(r => r.id === idLinea ? { ...r, ubiLocked: false } : r)
        );
        
        const tr = document.getElementById(`#row-${idLinea}`);                
        if(respuesta.data == idLinea){                         
            tr?.children[idxUbiRef.current]?.classList.add('alert-success');            
        }else if(typeof respuesta.data == "string"){                                   
            tr?.children[idxUbiRef.current]?.classList.add('alert-danger');                            
        }
    }

    const handleChangeNum1 = async (e, rowData) => { 
        let idLinea = rowData.id;
        let num1 = rowData.cantidad;        
        
        saveData(prev =>
            prev.map(r => r.id === idLinea ? { ...r, num1Locked: true } : r)
        );

        const dataForm = new FormData();      
        dataForm.append("validacion", apiKey());
        dataForm.append("idlinea", idLinea);
        dataForm.append("num1", num1);   
        const respuesta = await axios.post(getApiUrl(window.location.origin)+"/edirap/updateNum1", dataForm);
               
        saveData(prev =>
            prev.map(r => r.id === idLinea ? { ...r, num1Locked: false } : r)
        );
        
        const tr = document.getElementById(`#row-${idLinea}`);                
        if(respuesta.data == idLinea){                         
            tr?.children[idxCantidadRef.current]?.classList.add('alert-success');            
        }else if(typeof respuesta.data == "string"){                                   
            tr?.children[idxCantidadRef.current]?.classList.add('alert-danger');                            
        }
    }

    const handleChangeUni = async (e, rowData) => {            
        let idLinea = rowData.id;
        let idUni = rowData.articulo; 
        
        saveData(prev =>
            prev.map(r => r.id === idLinea ? { ...r, uniLocked: true } : r)
        );

        const dataForm = new FormData();      
        dataForm.append("validacion", apiKey());
        dataForm.append("idlinea", idLinea);
        dataForm.append("iduni", idUni);
        const respuesta = await axios.post(getApiUrl(window.location.origin)+"/edirap/updateUnidad",dataForm);        
                
        saveData(prev =>
            prev.map(r => r.id === idLinea ? { ...r, uniLocked: false } : r)
        );
        
        const tr = document.getElementById(`#row-${idLinea}`);                
        if(respuesta.data == idLinea){                         
            tr?.children[0]?.classList.add('alert-success');            
        }else if(typeof respuesta.data == "string"){                                   
            tr?.children[0]?.classList.add('alert-danger');                            
        }
    }
    
    const handleDeleteItem = (e, rowData) => {
        e.stopPropagation();
        let idLinea = e.target.id;
        swal({
            title: swaldelete.title,
            text: swaldelete.text.title,
            icon: "warning",
            buttons: {
                cancel : {text: swaldelete.btncancel.title, className:'btn btn-flat mr-1 btn-outline-secondary', visible: true},
                confirm : {text: swaldelete.btnconfirm.title, className:'btn btn-flat mr-1 btn-outline-danger btnSwalDelete'}
            } 
        }).then(confirmacion => {
            if(confirmacion){
                deleteLinea(idLinea);
            }
        })
    }

    const deleteLinea = async (idLinea) => {
        let spinner = document.getElementById(`spinTableLarge`);
        if(spinner) spinner.classList.remove('noDisplay');
        
        const dataForm = new FormData(); 
        dataForm.append("validacion", apiKey());
        dataForm.append("id", idLinea);
        const respuesta = await axios.post(getApiUrl(window.location.origin)+"/lineas/deletelineas",dataForm);      
        if(respuesta.data !== 0 ){
            const tr = document.querySelector("#\\#row-"+idLinea);
            if( tr ){ tr.remove(); }
            const auxData = $("."+id).DataTable().rows().data().filter(aux => {                       
                if(aux.id != idLinea){ return aux; }
            })
            saveData(auxData); 
        }else if(typeof respuesta.data == "string"){    
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});  
        }
        if( spinner ){ spinner.classList.add('noDisplay'); }          
    }

    const handleEditar = (e, rowData) => {
        e.stopPropagation();
        editar(e, rowData);
    }

    $.fn.dataTableExt.ofnSearch['html-input'] = function(value) {        
        if(/^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)$/.test(value) || /^(\d{4})-(\d\d)-(\d\d)$/.test(value)){            
            return value;
        }else{                           
            return value;
        }   
    };

    $.fn.dataTableExt.ofnSearch['html-input-uni'] = function(value) {
        if(optionSelectUni){
            const busqueda = optionSelectUni.filter(option => option.value == value)
            if( busqueda[0] ){ return busqueda[0].label; }
            else { return value; }  
        }else{ return null; }                                                  
    };

    $.fn.dataTableExt.ofnSearch['html-input-ubi'] = function(value) {
        if(optionSelectUbi){
            const busqueda = optionSelectUbi.filter(option => option.value == value)
            if( busqueda[0] ){ return busqueda[0].label; }
            else { return value; }  
        }else{ return null; }                                                        
    };

    function removeAccents ( data ) {
        if ( data.normalize ) {
            return data +' '+ data
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
        }
        return data;
    }
    var searchType = jQuery.fn.DataTable.ext.type.search;
    searchType.string = function ( data ) {
        return ! data ? '' : typeof data === 'string' ? removeAccents( data ) : data;
    };
    searchType.html = function ( data ) {
        return ! data ? '' : typeof data === 'string' ? removeAccents( data.replace( /<.*?>/g, '' ) ) : data;
    };

    return(
        <Fragment>
            {   loadingTable ? 
                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                    </div>
                :
                null
            }
            <div style={{overflowX: "auto"}}>
                <div id="spinTableLarge" className="noDisplay" style={{ textAlign: "center"}} >
                    <SpinnerFloat  />
                </div>           
                <table id={id} className={id+" table table-sm table-bordered table-striped table-hover dataTable"} style={{width:"99%"}} ></table>                
                <input
                    id="importFileToBBDD"
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    accept=".xls,.xlsx"
                    onChange={ e => handleImportFileToBBDD(e, saveLoadingTable, traduction, id, fnReloadTable, idRegImportExport)}
                />
            </div>   
        </Fragment>
    )
}

export default MiDataTableLarge;